/* eslint-disable max-len */
import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {BreadcrumbItem} from '../../../models/breadcrumb/breadcrumb-item';
import {RouterSegments} from '../../../models/router-segments';
import {Blueprint, BlueprintTypes} from '../../../models/blueprints/blueprint';
import {Solution} from '../../../models/service/solution';
import {AuthService} from '../../../services/auth/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ErrorPageService} from '../../../services/util/error-page.service';
import {translate} from '@jsverse/transloco';
import {BlueprintsService} from '../../../services/api/blueprints.service';
import {finalize, map, mergeMap} from 'rxjs/operators';
import {SolutionsService} from '../../../services/api/solutions.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {combineLatest, Observable, of, Subject, Subscription, interval} from 'rxjs';
import {InstancesService} from '../../../services/api/instances.service';
import {DataZone} from '../../../models/data-zone/data-zone';
import {DeployStatus} from '../../../models/deploy/deploy-status';
import {ConfigurationsService} from '../../../services/api/configurations.service';
import {Instance} from '../../../models/instance/instance';
import {Configuration} from '../../../models/configurations/configuration';
import {WorkflowTicketStatus} from '../../../models/workflow-approval/ticket-status';
import {OperationType} from '../../../models/workflow-approval/operation-type';
import {PathToLiveEnvironment} from 'src/app/models/blueprints/path-to-live-environment';
import {DeploymentClass} from '../../../models/instance-class';
import {PathToLiveConfiguration} from '../../../models/blueprints/path-to-live-configuration';
import {Deployment} from '../../../models/deploy/deployment';
import {DeployInstanceComponent} from '../deploy-instance/deploy-instance.component';
import {ConfirmationDialogComponent} from '../../../components/confirmation-dialog/confirmation-dialog.component';
import {ReportIssueComponent} from '../report-issue/report-issue.component';
import {Endpoint} from '../../../models/endpoint';
import {ViewEndpointsComponent} from '../view-endpoints/view-endpoints.component';
import {PathToLiveWorkflowComponent} from '../path-to-live-workflow/path-to-live-workflow.component';
import {UpdateConfigurationComponent} from '../update-configuration/update-configuration.component';
import {RequestUpdateConfigurationComponent} from '../request-update-configuration/request-update-configuration.component';
import {EnterpriseStepsConfig} from '../../../../assets/config/tour/steps/enterprise-steps-config';
import {EntityType} from '../../../models/workflow-approval/entity-type';
import {WorkflowApproval} from '../../../models/workflow-approval/workflow-approval';
import {UrlService} from '../../../services/util/url.service';
import {SidenavService} from '../../../services/util/sidenav.service';
import {DeploymentsService} from '../../../services/api/deployments.service';
import {MatDialog} from '@angular/material/dialog';
import {WorkflowService} from '../../../services/api/workflow.service';
import {TourService} from '../../../services/util/tour.service';
import {getDiffDays} from '../../../services/util/utils';
import {Permission} from '../../../models/principal/permission';
import {SolutionVersion} from 'src/app/models/service/solution-version';
import {SolutionVersionsInfo} from 'src/app/models/service/solution-versions-info';
import {SolutionVersionsService} from 'src/app/services/util/solution-versions.service';
import {PermissionsService} from '../../../services/util/permissions.service';
import {ChangeTask} from '../../../models/service/change-task';
import {ChangeState} from '../../../models/service/change-state';
import {NotificationsService} from 'src/app/services/api/notifications.service';
import {EndpointType} from 'src/app/models/endpoint-type';
import moment from 'moment';
import {
  RequestDeployInstanceDialogComponent
} from 'src/app/main/service/request-deploy-instance-dialog/request-deploy-instance-dialog.component';
import {ConfigurationApplicationStatus, ConfigurationState} from 'src/app/models/configurations/configuration-state';
import {ViewUpdateResultsComponent} from 'src/app/main/service/view-update-results/view-update-results.component';
import {Constants} from 'src/app/models/constants';
import {InstallationSpecificationService} from 'src/app/services/util/installation-specification.service';
import {
  ViewServiceDefinitionVersionDetailsComponent
} from 'src/app/components/view-service-definition-version-details/view-service-definition-version-details.component';
import {CapabilitiesGroup, Capability, CapabilityType} from 'src/app/models/service/capability';
import {TenantsService} from 'src/app/services/api/tenants.service';
import {ContactUsDialogComponent} from '../../../layout/toolbar/contact-us-dialog/contact-us-dialog.component';
import {BlueprintVersion} from '../../../models/blueprints/blueprint-version';
import {ErrorDialogComponent} from 'src/app/components/error-dialog/error-dialog.component';
import {UpdateDefinitionComponent} from '../update-definition/update-definition.component';
import { InstallationSchemaPropertyType } from 'src/app/models/service/installation-schema-property-type';
import { DateTimeService } from 'src/app/services/util/date-time.service';
import { SecretComponent } from 'src/app/components/secret/secret.component';
import { Title } from '@angular/platform-browser';
import { VerifypopupComponent } from 'src/app/components/verifypopup/verifypopup.component';
import { SkiptestPopupComponent } from 'src/app/components/skiptest-popup/skiptest-popup.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ServiceCardInfo } from 'src/app/models/service/service-card-info';
import { ToastrService } from 'src/app/services/util/toastr.service';
import { ClipboardService } from 'ngx-clipboard';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions, Datazone, Attributes} from 'src/app/models/principal/permission';
import { ConfigDialogLiveComponent } from 'src/app/components/config-dialog-live-component/config-dialog-live-component';

const REQUIRED_PERMISSIONS: Permission[] = [
  Permission.DEPLOY_CONFIG_INSTANCE,
  Permission.UPDATE_CONFIG_INSTANCE,
  Permission.TERMINATE_CONFIG_INSTANCE,
  Permission.CONFIGURE_SERVICE,
  Permission.PUBLISH_CONFIG_PACK,
  Permission.TERMINATE_PTL_INSTANCE,
  Permission.UPDATE_PTL_INSTANCE,
  Permission.DEPLOY_PTL_INSTANCE,
  Permission.EDIT_PTL_WORKFLOW,
  Permission.DEFINE_PTL_WORKFLOW,
  Permission.DELETE_SERVICE_DEFINITION,
  Permission.CREATE_SANDBOX,
  Permission.CREATE_SERVICE_DEFINITION,
  Permission.UPDATE_SERVICE_DEFINITION,
  Permission.UPDATE_SECRETS,
  Permission.NO_SERVICES,
  Permission.SERVICE_DEF_MENU,
  Permission.APPLY_RELEASE_PACKAGE,
  Permission.APPLY_RELEASE_PACKAGE_HOTFIX,
  Permission.APPLY_RELEASE_PACKAGE_TILL_TEST
];

const UPDATED_REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.INSTANCE_CREATE_DATAZONE_NONPII,
    action: Permissions.INSTANCE_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_CREATE_DATAZONE_PII,
    action: Permissions.INSTANCE_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_CREATE_DATAZONE_LIVE,
    action: Permissions.INSTANCE_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_REDEPLOY_DATAZONE_NONPII,
    action: Permissions.INSTANCE_REDEPLOY,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_REDEPLOY_DATAZONE_PII,
    action: Permissions.INSTANCE_REDEPLOY,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_REDEPLOY_DATAZONE_LIVE,
    action: Permissions.INSTANCE_REDEPLOY,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.BLUEPRINT_CREATE,
    action: Permissions.BLUEPRINT_CREATE
  },
  {
    key: PermissionKeys.BLUEPRINT_READ,
    action: Permissions.BLUEPRINT_READ,
  },
  {
    key: PermissionKeys.BLUEPRINT_DELETE,
    action: Permissions.BLUEPRINT_DELETE,
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_NONPII,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_PII,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_LIVE,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_CONFIG_DATAZONE_NONPII,
    action: Permissions.INSTANCE_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_CONFIG_DATAZONE_PII,
    action: Permissions.INSTANCE_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_CONFIG_DATAZONE_LIVE,
    action: Permissions.INSTANCE_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_DELETE_DATAZONE_NONPII,
    action: Permissions.INSTANCE_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_DELETE_DATAZONE_PII,
    action: Permissions.INSTANCE_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_DELETE_DATAZONE_LIVE,
    action: Permissions.INSTANCE_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_EXTEND_DATAZONE_NONPII,
    action: Permissions.INSTANCE_EXTEND,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_EXTEND_DATAZONE_PII,
    action: Permissions.INSTANCE_EXTEND,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_EXTEND_DATAZONE_LIVE,
    action: Permissions.INSTANCE_EXTEND,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.BLUEPRINT_UPDATE,
    action: Permissions.BLUEPRINT_UPDATE,
  }
];

@Component({
    selector: 'app-blueprint-summary',
    templateUrl: './blueprint-summary.component.html',
    styleUrls: ['./blueprint-summary.component.scss'],
    animations: [
        trigger('rotate', [
            transition('void=>*', [style({ transform: 'rotate(0)' })]),
            transition('* => *', [
                style({ transform: 'rotate(0)' }),
                animate('650ms ease-in-out', style({ transform: 'rotate(360deg)' })),
            ])
        ])
    ],
    standalone: false
})
export class BlueprintSummaryComponent implements OnInit {
private destroyRef = inject(DestroyRef);
  capabilities: Capability[];
  capabilitiesGroups: CapabilitiesGroup[];
  CapabilityType = CapabilityType;
  service: Solution;
  serviceVersionsInfo: SolutionVersionsInfo;
  serviceVersions: SolutionVersion[];
  publishedServiceVersions: SolutionVersion[];
  permissionsMap: { [key: string]: boolean };
  Permission = Permission;
  blueprintType = BlueprintTypes;
  errorMessage: any;
  sandboxCreationStatus: any;
  availableEndpoints = 0;
  endpointView = false;
  gotoWorkBench = false;
  liveReleaseData: any;
  environment: any;
  instanceName: any;
  state = 'default';
  count: any;
  defaultState;
  serviceDefinitionUpdate = false;
  updateReleasePackage: any;
  isAMR: boolean;
  latestReleaseVersion: any;
  enterPriseSandbox: boolean;
  releaseVersion: any;
  sortedSolutionVersionId: any;
  PermissionKeys = PermissionKeys;

  ConfigurationApplicationStatus = ConfigurationApplicationStatus;

  readonly INSTANCE_AVAILABLE_STATES = [DeployStatus.DEPLOYED, DeployStatus.FAILED, DeployStatus.TERMINATION_FAILED,
    DeployStatus.CONFIGURING, DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.TESTED, DeployStatus.UPDATED,
    DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED, DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED];

  readonly INSTANCE_FILTERED_STATES = [DeployStatus.DEPLOYED, DeployStatus.FAILED,
    DeployStatus.CONFIGURING, DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.TESTED, DeployStatus.UPDATED,
    DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED, DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED];

  readonly INSTANCE_DEPLOYED_STATES = [DeployStatus.DEPLOYED, DeployStatus.CONFIGURING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.UPDATING, DeployStatus.UPDATED, DeployStatus.TESTED,
    DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED, DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED];

  readonly INSTANCE_DEPLOYED_STATES_FAILED = [DeployStatus.FAILED, DeployStatus.TERMINATION_FAILED];

  STATUS_ICON = {
    [DeployStatus.DEPLOYING]: 'change_circle',
    [DeployStatus.TERMINATING]: 'change_circle',
    [DeployStatus.DEPLOYED]: 'done',
    [DeployStatus.TERMINATED]: 'close',
    [DeployStatus.TERMINATION_FAILED]: 'error_outline',
    [DeployStatus.NOT_DEPLOYED]: 'schedule',
    [DeployStatus.FAILED]: 'close',
    [DeployStatus.FAILOVER_APPLYING]: 'change_circle',
    [DeployStatus.FAILBACK_APPLYING]: 'change_circle',
    [DeployStatus.PRE_FAILBACK_APPLYING]: 'change_circle',
    [DeployStatus.FAILOVER_FAILED]: 'close',
    [DeployStatus.FAILBACK_FAILED]: 'close',
    [DeployStatus.PRE_FAILBACK_FAILED]: 'close'
  };

  STATUS_CLASS = {
    [DeployStatus.DEPLOYING]: 'orange-oval',
    [DeployStatus.TERMINATING]: 'orange-oval',
    [DeployStatus.DEPLOYED]: 'green-oval',
    [DeployStatus.TERMINATED]: 'green-oval',
    [DeployStatus.TERMINATION_FAILED]: 'warn-solid-bg',
    [DeployStatus.NOT_DEPLOYED]: 'neutral-blue-6-oval',
    [DeployStatus.FAILED]: 'warn-solid-bg',
    [DeployStatus.FAILOVER_APPLYING]: 'orange-oval',
    [DeployStatus.FAILBACK_APPLYING]: 'orange-oval',
    [DeployStatus.PRE_FAILBACK_APPLYING]: 'orange-oval',
    [DeployStatus.FAILOVER_FAILED]: 'warn-solid-bg',
    [DeployStatus.FAILBACK_FAILED]: 'warn-solid-bg',
    [DeployStatus.PRE_FAILBACK_FAILED]: 'warn-solid-bg'
  };

  CONFIGURATION_FINAL_STATES = Constants.CONFIGURATION_FINAL_STATES;
  InstallationSchemaPropertyType = InstallationSchemaPropertyType;

  breadcrumbItems: BreadcrumbItem[];
  tenant: string;
  dataLoaded: boolean;
  isLive: boolean;
  isSandbox: boolean;

  blueprint: Blueprint;
  blueprintSingleVersion: Blueprint;
  blueprintVersion: BlueprintVersion;
  trialStatus: string;

  DataZone = DataZone;
  DeployStatus = DeployStatus;
  RouterSegments = RouterSegments;

  allInstances: Instance[];
  devInstance: any;
  pathToLiveInstances: any[];
  devInstances: any;
  testDataZoneInstances: any[];
  piiDataZoneInstances: any[];

  configurations: Configuration[];

  groupedWorkflowApprovals: Map<string, any> = new Map();
  OperationType = OperationType;
  TicketStatus = WorkflowTicketStatus;
  PathToLiveEnvironment = PathToLiveEnvironment;
  showCharts: boolean;
  changeTaskApplying: boolean;

  workbenchUrl: string;
  isLoading = false;
  updateWindowPolicy: string;
  showTopBanner = true;
  isInstance: boolean;

  loadDataSubscription: Subscription;
  extendSandbox = false;
  selectedCapabilities: Capability[];
  includedCapabilities: Capability[];
  viewReleaseNotes: string;
  currentDate = new Date();
  deployedDate = new Date();
  tenantDetails: any;

  configTypeEndpoints: any;
  accessTypeEndpoints: any;
  exploreTypeEndpoints: any;
  otherTypeEndpoints: any;

  progressIntervalSubscription: Subscription;
  demoInstance: Instance;
  showStepsLoadingSection = true;
  isInit = false;
  isEndpointAvailable: boolean;
  enterpriseClient: boolean;
  devInstanceEnvironment: any;
  blueprintLatestVersion: any;
  liveDataZone: any;
  blueprintsVersionList: any;
  getVersion: any;
  deployedVersion: any;
  inProgressVersion: any;
  isInstanceSection = true;
  isServiceDefinitionSection = false;
  isNewServiceDefinitionVersion: boolean;
  configStateMessageExpireTime = 60 * 5;
  configStateSubscription: Subscription;
  buildNumber: any;

  blueprintId: string;
  instanceId: string;
  descriptionArray: any;
  createNewBtnEnable = false;
  configStateVerify = false;
  configLastRecord: any = [];
  liveInstanceId: any;
  devDeploymentClass: any;
  skipTest: boolean;
  extendSandboxMessage: boolean;
  bluerprintById: Blueprint;
  instanceBlueprint: Instance[];
  isDevInstanceDeployed: any;
  deploymentClass = DeploymentClass;
  updateMessageRemainingTime: any;
  copy = false;
  releaseManager = false;
  updatedPermissionsMap: { [key: string]: boolean };
  preProdInstances: any;
  loader: boolean;
  isExternalClient: boolean;

  constructor(
    private authService: AuthService,
    private matDialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private errorPageService: ErrorPageService,
    private blueprintsService: BlueprintsService,
    private solutionsService: SolutionsService,
    private instanceService: InstancesService,
    private configurationsService: ConfigurationsService,
    private urlService: UrlService,
    private sidenavService: SidenavService,
    private deploymentsService: DeploymentsService,
    private dialog: MatDialog,
    private workflowService: WorkflowService,
    private tourService: TourService,
    private solutionVersionsService: SolutionVersionsService,
    private permissionsService: PermissionsService,
    private notificationsService: NotificationsService,
    private router: Router,
    private installationSpecificationService: InstallationSpecificationService,
    private tenantsService: TenantsService,
    private dateTimeService: DateTimeService,
    private readonly titleService: Title,
    private toastrService: ToastrService,
    private clipboardApi: ClipboardService) {
  }

  ngOnInit(): void {
    this.asyncInstances();
  }

  asyncInstances(): void {
    this.loader = true;
    this.tenant = this.authService.principal.provider;
    this.blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    // this.enterpriseClient = this.authService.hasPermission(Permission.VIEW_ENTERPRISE);
    this.releaseManager = this.authService.hasPermission(Permission.APPLY_RELEASE_PACKAGE_HOTFIX);
    this.updatedPermissionsMap = this.permissionsService.resolveAPIPermissions(UPDATED_REQUIRED_PERMISSIONS);
    if (!this.updatedPermissionsMap[PermissionKeys.BLUEPRINT_READ]) {
      this.router.navigate(['/', this.tenant, RouterSegments.UNAUTHORIZED], {skipLocationChange: true});
    }
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);
    this.devDeploymentClass = DeploymentClass.D;

    this.subscribeForNotifications();
    this.subscribeForNotification();

    // If navigated to the same route with different parameters (through notifications for example).
    this.activatedRoute.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loadService();
      });

    this.tenantsService.getTenantDetails()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(tenantData => {
        this.tenantDetails = tenantData;
      });

    // this.tenantsService.getTenant(this.tenant)
    //  .pipe(takeUntilDestroyed(this.destroyRef))
    //   .subscribe((tenant: any) => {
    //     if (tenant?.origin.toLowerCase() === 'external') {
    //       this.isExternalClient = true;
    //     } else {
    //       this.isExternalClient = false;
    //     }
    //   });

    this.isNewServiceDefinitionVersion = !!history.state.data;
    this.gotoSection(history.state.data ? history.state.data : BlueprintTypes.INSTANCES);
  }

  /**
   * Opens the form for creating the configuration instance and when the user is done
   * providing the needed information the proper method is called to proceed further
   */
  openCreateConfigurationInstanceForm(): void {
    const devInstance = DataZone.DEVELOPMENT;
    if(this.blueprintsVersionList[0]) {
    const data = {
      title: translate('INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.TITLE'),
      subtitle: devInstance.charAt(0).toUpperCase() + devInstance.slice(1),
      deployment: {
        blueprintId: this.blueprint.id,
        dataZone: DataZone.DEVELOPMENT,
        deploymentClass: DeploymentClass.D,
        blueprintVersionId: this.blueprintsVersionList[0]?.id
      } as Deployment,
      service: this.service,
      tenantDetails: this.tenantDetails,
      blueprintsVersionList: this.blueprintsVersionList,
      instanceBlueprint: this.instanceBlueprint,
      checkDeploymentClass: DeploymentClass.D


    };
    this.openDeployInstance(data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(deployment => {
        if (deployment) {
          this.loadData();
        }
      });
    } else {
      this.instanceErrorModal(this.blueprintsVersionList.error);
    }
  }

  applyLocalConfig(data): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      autoFocus: false,
      width: '566px',
      data: {
        title: translate(`BLUEPRINT_SUMMARY.CONFIRM_LOCAL_APPLY.TITLE`),
        message: translate(`BLUEPRINT_SUMMARY.CONFIRM_LOCAL_APPLY.MESSAGE`),
        confirmButtonText: translate('BUTTONS.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.instanceService.applyLocalConfig(data.id, 'local_config')
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((data) => {
            if(data){
              this.toastrService.clear();
            setTimeout(() => {
              this.toastrService.checkboxMessage(
                `${data?.messages}`
                );
            }, 500);
            }
            this.loadData();
          },
          (error) => {
            this.matDialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '566px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('NOTIFICATIONS.APPLY_LOCAL_CONFIGURATION_FAILED'),
                description: error,
              }
            });
        });
        }
      });
  }

  instanceErrorModal(error?: any): void {
    this.matDialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '566px',
      panelClass: 'flex-dialog',
      data: {
        title:  translate('NOTIFICATIONS.INSTANCE_FAILED'),
        description: error,
      }
    });
  }

  secret(instance): void {
    this.instanceId = instance?.id;
    this.instanceName = instance?.name;
    this.environment = (instance.deploymentClass === this.devDeploymentClass ? 'DEV' : instance.environment);
    this.matDialog.open(SecretComponent, {
      minHeight: '680px',
      minWidth: '1080px',
      panelClass: 'flex-dialog',
      data: {
        serviceName:  this.service?.name,
        serviceDefinition : this.isBlueprintsVersionlAvaliable(this.blueprintsVersionList,
          instance.blueprintVersionId)?.length? this.getVersion[0]?.version: '-',
        blueprintName: this.blueprint?.name,
        environment : this.environment,
        instanceName: this.instanceName,
        instanceId: this.instanceId,
        capabilities: this.isBlueprintsVersionlAvaliable(this.blueprintsVersionList,
          instance.blueprintVersionId)?.length? this.getVersion[0]?.capabilities: '-',
      }
    });
  }

  onDeploy(instance: Instance, workflowApproval: WorkflowApproval, event): void {
    if (!this.INSTANCE_DEPLOYED_STATES.includes(instance.previousInstance?.status) || !this.updatedPermissionsMap[PermissionKeys.INSTANCE_CREATE_DATAZONE_LIVE] || !this.updatedPermissionsMap[PermissionKeys.INSTANCE_CREATE_DATAZONE_PII]){
      this.matDialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    } else {
    event.stopPropagation();
    // This code is commented to temporarily remove workflow approval for deploying PROD instance

    // For live instance request data is stored in the workflow approval
    // if (instance.dataZone === DataZone.LIVE) {
    //   const deployment = workflowApproval.data.requestBody;
    //   const maintenanceWindow = workflowApproval.data.maintenanceWindow;
    //   const data = {
    //     title: `${translate('INSTANCE_SUMMARY.DEPLOY')} ${instance.environment}`,
    //     subtitle: this.service.name,
    //     deployment,
    //     requestDescription: workflowApproval.data.requestDescription,
    //     maintenanceWindow
    //   };
    //   this.sidenavService.openInRightSidenav(ConfirmDeployInstanceDialogComponent, data)
    //   .pipe(
    //     mergeMap(deploymentData => {
    //       if (deploymentData) {
    //         deploymentData.dayOfTheWeek = maintenanceWindow.dayOfTheWeek;
    //         deploymentData.startingHour = maintenanceWindow.startingHour;
    //         deploymentData.endingHour = maintenanceWindow.endingHour;
    //         return this.deployInstance(deploymentData);
    //       }
    //       return of(null);
    //     }),
    //     takeUntilDestroyed(this.destroyRef)
    //   ).subscribe(response => {
    //     if (response) {
    //       this.updateMaintenanceWindow();
    //     }
    //   });
    // } else {
      this.serviceDefinitionUpdate = false;
      if(this.blueprintsVersionList[0]) {
        this.openDeployPTLInstanceDialog(instance);
      } else {
        this.instanceErrorModal(this.blueprintsVersionList.error);
      }
    }
  }

  onReDeploy(instance: Instance, event): void {
    event.stopPropagation();
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('VERSIONS.REDEPLOY_TITLE'),
        message: translate('VERSIONS.REDEPLOY_SUBTITLE'),
        confirmButtonText: translate('DIALOG.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.instanceService.redeployInstance(instance.id)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.loadBlueprint());
        }
      });
  }

  openDeployPTLInstanceDialog(instance: any): void {
    this.loadBlueprint();
    const data = this.buildDeployDialogData(instance, `${translate('INSTANCE_SUMMARY.DEPLOY')}`);
    let serviceDefinitionData = [];

    if (this.devInstance && instance.previousInstance?.status === DeployStatus.DEPLOYED) {
      serviceDefinitionData = this.serviceDefinitionsForInstance(instance);
    } else {
      serviceDefinitionData = this.blueprintsVersionList;
      if (instance.previousInstance?.status === DeployStatus.DEPLOYED && instance.previousInstance?.blueprintVersionId) {
        serviceDefinitionData = serviceDefinitionData.filter(
          item => item.id === instance.previousInstance?.blueprintVersionId);
      }
    }

    data.blueprintsVersionList = serviceDefinitionData;
    data.checkDeploymentClass = instance.deploymentClass;
    data.bluerprintById = this.bluerprintById.pathToLiveConfiguration;

    this.openDeployInstance(data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(deployment => {
        if (deployment) {
          this.loadBlueprint();
        }
      });
  }

  openDeployInstance(data: any): Observable<any> {
    this.serviceDefinitionUpdate = false;
    let currentBuildNumber;
    if(this.isSandbox) {
      currentBuildNumber= this.serviceVersionsInfo?.devVersion?.version;
    } else {
      currentBuildNumber = this.serviceVersionsInfo?.currentVersion?.version;
    }
    data.currentBuildNumber = currentBuildNumber;
    data.buildNumber = this.publishedServiceVersions;
    data.blueprint = this.blueprint;
    data.buildNumber = data.buildNumber.filter(item => item.releaseVersion);
    if (data.checkDeploymentClass === DeploymentClass.A) {
      const getSolutionVersionId = data.instanceBlueprint.find(item=> item.environment === PathToLiveEnvironment.PREPROD).solutionVersionId;
      data.buildNumber = data.buildNumber.filter(item => item.releaseVersion && item.id === getSolutionVersionId);
    } else {
      data.buildNumber = data.buildNumber.filter(item => item.releaseVersion);
    }
    data.allInstances = this.allInstances;
    return this.sidenavService.openInRightSidenav(DeployInstanceComponent, data)
      .pipe(
        mergeMap((deploymentData) => {
          if (deploymentData) {
            return this.deployInstance(deploymentData);
          }
          return of(null);
        })
      );
  }


  getBuildVersion(solutionVersionId: any): string {
    const solnVersion = this.serviceVersions.find(v => v.id === solutionVersionId);
    return solnVersion?.releaseVersion;
  }

  /**
   * Terminates an instance
   *
   * @param instance - the instance to be terminated
   */
  terminate(instance: Instance): void {
    if (!this.INSTANCE_AVAILABLE_STATES.includes(instance.status) ||
    (instance.configurationStates?.length > 0 && instance.latestConfigurationState?.status !== ConfigurationApplicationStatus.SUCCESS &&
      instance.latestConfigurationState?.status !== ConfigurationApplicationStatus.VERIFIED)) {
        this.matDialog.open(GenericErrorComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog'
        });
    } else {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_SUMMARY.TITLE'),
          message: translate('INSTANCE_SUMMARY.CONFIRM_TERMINATION'),
          confirmButtonText: translate('BUTTONS.TERMINATE')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.instanceService.deleteInstance(instance.id)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(() => this.loadBlueprint());
          }
        });
    }
  }

  serviceDefinitionsForInstance(instance): any {
    let serviceDefinitionData = this.blueprintsVersionList;
    const requiredEnvironment = this.blueprint.pathToLiveConfiguration.find(
      ptl => ptl.environment === instance.environment && ptl.instanceId === instance.id)?.requires;
    if(requiredEnvironment === PathToLiveEnvironment.PREPROD) {
      const filterData = serviceDefinitionData.filter(item => item.id === instance.previousInstance?.blueprintVersionId);
      const deployedVersion = this.blueprintsVersionList.find(item => item.id === instance.blueprintVersionId);
      const previousVersions = this.blueprintsVersionList.filter(version => version?.version <= deployedVersion?.version);
      const appendData = [...filterData, ...previousVersions];
      const removeDuplicates = this.removeDuplicateVersions(appendData);
      serviceDefinitionData = removeDuplicates.sort((a,b) => a.version - b.version);
    } else {
      let devServiceDefinitions = [];
      let previousVersions= [];
      devServiceDefinitions = this.blueprintsVersionList;
      const deployedVersion = this.blueprintsVersionList.find(item => item.id === instance.blueprintVersionId);
      previousVersions = this.blueprintsVersionList.filter(version => version?.version <= deployedVersion?.version);
      const appendData = [...devServiceDefinitions, ...previousVersions];
      const removeDuplicateVersions = this.removeDuplicateVersions(appendData);
      serviceDefinitionData = removeDuplicateVersions.sort((a,b) => a.version - b.version);
    }
    return serviceDefinitionData;
  }

  removeDuplicateVersions(devServiceDefinitions): any {
    const unique = devServiceDefinitions.reduce((acc, version) => {
      if(!acc.includes(version)){
        acc.push(version);
      }
      return acc;
    }, []);
    return unique;
  }

  showViewDetails(version?): void {
    let selectedVersion: any;
    if(this.isSandbox) {
      this.blueprintsService.getBlueprintVersionById(this.blueprintId, this.blueprintLatestVersion.id)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        blueprintVersion => {
          selectedVersion = blueprintVersion;
          this.showViewDetailsInDetail(selectedVersion);
        }
      );
    } else {
      selectedVersion = version;
      this.showViewDetailsInDetail(selectedVersion);
    }
  }

  showViewDetailsInDetail(selectedVersion): any {
    let installationSpecificationForms = [];
    if (this.serviceVersionsInfo.currentVersion?.installationSpecification &&
       this.serviceVersionsInfo.currentVersion.installationSpecification !== '' && selectedVersion?.installDocRaw && selectedVersion) {
      try
      {
        JSON.parse( this.serviceVersionsInfo.currentVersion.installationSpecification );
        installationSpecificationForms = this.installationSpecificationService
        .buildDynamicForms(this.serviceVersionsInfo.currentVersion.installationSpecification);
      }
      catch (error)
      {
        installationSpecificationForms = this.installationSpecificationService
        .buildDynamicForms(atob(this.serviceVersionsInfo.currentVersion.installationSpecification));
      }
      installationSpecificationForms.forEach(installationSpecificationForm => {
        this.mapProperties(installationSpecificationForm, selectedVersion?.installDocRaw);
      });

      const installDocRaw = Object.keys(selectedVersion?.installDocRaw);
      installationSpecificationForms = installationSpecificationForms.filter(item => installDocRaw.includes(item.property.name));

      this.dialog.open(ViewServiceDefinitionVersionDetailsComponent, {
        panelClass: 'default-dialog-wrapper',
        autoFocus: false,
        data: {
          dynamicForm: installationSpecificationForms,
          serviceName: this.service.name,
          blueprintName: this.blueprint.name,
          sysgen: this.blueprint.onboardingProcess,
          region: this.tenantDetails.region,
          // region: this.tenantDetails.temenosRegion,
          capabilities: selectedVersion?.capabilities
        }
      });
    } else {
    this.matDialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '566px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('NOTIFICATIONS.NOT_AVAILABLE'),
        description: translate('NOTIFICATIONS.INSTALLATION_SPECIFICATION_NOT_AVAILABLE'),
            }
        });
      }
  }

  mapProperties(installationSpecificationForm, selectedVersion): void {
    const keys = Object.keys(selectedVersion);
    keys.forEach(key => {
      if (key === installationSpecificationForm?.property?.name) {
        const properties = installationSpecificationForm.property?.properties;
        if (installationSpecificationForm.property?.type === InstallationSchemaPropertyType.ARRAY) {
          installationSpecificationForm.property.items.enum = selectedVersion[key];
        }
        if(properties) {
          properties.forEach(property =>{
            const selectedItem = Object.keys(selectedVersion[key]);
            selectedItem.forEach(item => {
              if (property?.name === item) {
                property.value = selectedVersion[key][item];
              }
            });
          });
        }
      }
    });
  }

  /**
   * Reports an issue related with the instance
   *
   * @param instance - the instance for which we are going to report the issue
   */
  reportIssue(instance: Instance): void {
    const deployedVersion = this.blueprintsVersionList.filter(item => item.id === instance.blueprintVersionId);
    const releaseVersionText = this.getBuildVersion(instance.solutionVersionId);
    const isAMR = releaseVersionText && this.solutionVersionsService.releaseVersion(releaseVersionText) ? true : false;
    if (instance.deploymentClass === DeploymentClass.D) {
      instance.environment = 'DEV';
    }
    const data = {
      title: translate('INSTANCE_SUMMARY.REPORT_ISSUE.TITLE'),
      subtitle: '',
      report: {
        service: this.service,
        blueprint: this.blueprint,
        instance
      },
      configurations: this.configurations,
      buildNumber: this.buildNumber,
      version: deployedVersion[0]?.version,
      releaseVersion: releaseVersionText,
      isAMR
    };

    this.sidenavService.openInRightSidenav(ReportIssueComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  openViewEndpointsComponent(instance: Instance, event): void {
    event.stopPropagation();
    const data = {
      instanceName: instance.name,
      endpoints: instance.endpoints,
      title: translate('VIEW_ENDPOINTS.TITLE')
    };

    this.sidenavService.openInRightSidenav(ViewEndpointsComponent, data);
  }

  stopPropagation(event): void {
    event.stopPropagation();
  }

  openServiceDefinitionComponent(instance: Instance): void {
    if (this.blueprintsVersionList?.length <= 1 || (!this.INSTANCE_AVAILABLE_STATES.includes(instance?.status))) {
      this.matDialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    } else {
      this.serviceDefinitionUpdate = false;
      const findDeployedVersion = this.blueprintsVersionList.filter(item => item.id === instance.blueprintVersionId);
      this.deployedVersion = findDeployedVersion[0]?.version;
      const serviceDefinitionData =
      instance.deploymentClass === DeploymentClass.D ? this.blueprintsVersionList : this.serviceDefinitionsForInstance(instance);

      const data = {
        instance,
        title: translate('INSTANCE_SUMMARY.SERVICE_DEFINITION.TITLE'),
        subtitle: instance.name,
        serviceName: this.blueprint.name,
        blueprintsVersionList: serviceDefinitionData,
        deployedVersion: this.deployedVersion
      };
      this.sidenavService.openInRightSidenav(UpdateDefinitionComponent, data)

        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(newDefinition => {
          this.serviceDefinitionUpdate = true;
          if (newDefinition) {
            this.instanceService.applyDefinition(newDefinition.id, instance.id)
              .pipe(takeUntilDestroyed(this.destroyRef));
            this.loadBlueprint();
          }
        });
    }
  }

  /**
   * Opens the appropriate form to define a workflow
   */
  defineWorkflow(): void {
    this.sidenavService.openInRightSidenav(PathToLiveWorkflowComponent, {
      service: this.service,
      pathToLiveConfiguration: this.blueprint.pathToLiveConfiguration,
      devInstance: this.devInstance,
      tenant: this.tenantDetails
    })
      .pipe(
        mergeMap(pathToLiveConfiguration => {
          if (pathToLiveConfiguration) {
            // Clone selected blueprint in case that update is not successfully
            return this.blueprintsService.updateBlueprint({ ...this.blueprint, pathToLiveConfiguration });
          } else {
            return of(null);
          }
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((result: Blueprint) => {
        if (result) {
          this.blueprint.pathToLiveConfiguration = result.pathToLiveConfiguration;
          this.loadData();
        }
      },
      (error) => {
        this.matDialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('NOTIFICATIONS.UPDATE_SERVICE_DEFINITION_FAILED'),
            description: error,
          }
        });
      });
  }

  /**
   * Contains the logic to be executed when Update button is pressed
   * in order to update the applied configuration
   *
   * First case - If requires is null/undefined
   * If we don't have any current configuration - we use all the configurations from dev
   * If we have a current configuration - we filter all the configurations from dev to have
   * a newer date generated than the one applied currently
   *
   * Second case - If requires has value
   * If we don't have any current configuration - we use all the applied configurations from the previous/required env
   * If we have a current configuration - we filter all the applied configurations from the previous env to have
   * a newer date generated than the one applied currently
   *
   * @param instance - the row data as instance object
   */
  updateInstance(instance: Instance, workflowApproval: WorkflowApproval, configStatus): void {
    if (instance?.latestConfigurationState?.instanceId === instance.id && !instance?.latestConfigurationState?.status) {
      this.matDialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    } else {
      if(instance.dataZone === DataZone.LIVE && !this.configStateVerify && configStatus !== ConfigurationApplicationStatus.VERIFIED) {
        this.matDialog.open(VerifypopupComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
        })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(data => {
          if (data) {
            const dataVerify = localStorage.getItem('verifyUpdate');
            if(configStatus === ConfigurationApplicationStatus.VERIFIED) {
              this.configStateVerify = true;
            }
            if (dataVerify === 'true') {
              this.openRequestUpdateConfiguration(instance, this.getAvailableConfigurations(instance));
              //TODO: Commenting the below code as approval is not needed for now
              /*const requestBody = workflowApproval.data.requestBody;
              this.applyConfiguration(requestBody.id, requestBody.instanceId);*/
            }
            else if(dataVerify === 'false') {
              this.openUpdateConfiguration(instance, this.getAvailableConfigurations(instance));
            }
          }
        });
      } else {
          this.openUpdateConfiguration(instance, this.getAvailableConfigurations(instance));
      }
    }
  }

  requestDeployApproval(instance: Instance): void {
    const data = this.buildDeployDialogData(instance, `${translate('INSTANCE_SUMMARY.REQUEST_DEPLOY')}`);
    this.sidenavService.openInRightSidenav(RequestDeployInstanceDialogComponent, data)
      .pipe(
        mergeMap((requestDeployment) => {
          if (requestDeployment) {
            const deploymentData = requestDeployment.deployment;
            const maintenanceWindow = {
              dayOfTheWeek: deploymentData.dayOfTheWeek,
              startingHour: deploymentData.startingHour,
              endingHour: deploymentData.endingHour
            };

            delete deploymentData.dayOfTheWeek;
            delete deploymentData.startingHour;
            delete deploymentData.endingHour;

            const workflowApprovalEntry = {
              operationType: OperationType.CREATE_INSTANCE,
              entity: {
                entityId: this.blueprint.id,
                entityType: EntityType.BLUEPRINT
              },
              data: {
                targetEnvironment: instance.environment,
                requestBody: deploymentData,
                maintenanceWindow,
                requestDescription: requestDeployment.requestDescription
              },
            } as WorkflowApproval;
            // return this.workflowService.postWorkflowApproval(workflowApprovalEntry);
          }

          return of(null);
        }),
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((workflowEntry) => {
      if (workflowEntry) {
        this.updateWorkflowEntry(workflowEntry);
      }
    });
  }

  requestUpdateApproval(instance: Instance): void {
    const data = {
      title: translate('INSTANCE_SUMMARY.UPDATE_CONFIGURATION.TITLE'),
      subtitle: instance.name,
      environment: instance.environment,
      availableConfigurations: this.getAvailableConfigurations(instance)
    };
    this.sidenavService.openInRightSidenav(UpdateConfigurationComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(newConfiguration => {
        if (newConfiguration) {
          const workflowApprovalEntry = {
            operationType: OperationType.UPDATE_INSTANCE,
            entity: {
              entityId: instance.id,
              entityType: EntityType.INSTANCE
            },
            data: {
              requestBody: {
                id: newConfiguration.id,
                instanceId: instance.id,
              }
            }
          } as WorkflowApproval;
          // this.workflowService.postWorkflowApproval(workflowApprovalEntry)
          //   .pipe(takeUntilDestroyed(this.destroyRef))
          //   .subscribe(workflowEntry => this.updateWorkflowEntry(workflowEntry));
        }
      });
  }

  abortWorkflowAproval(workflowApproval: WorkflowApproval): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      autoFocus: false,
      width: '566px',
      data: {
        title: translate(`BLUEPRINT_SUMMARY.WORKFLOW_APPROVAL.${workflowApproval.operationType}.TITLE`),
        message: translate(`BLUEPRINT_SUMMARY.WORKFLOW_APPROVAL.${workflowApproval.operationType}.CONFIRM_ABORT`),
        confirmButtonText: translate('BUTTONS.ABORT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          workflowApproval.aborting = true;
          // this.workflowService.deleteWorkflowApproval(workflowApproval.id)
          //   .pipe(takeUntilDestroyed(this.destroyRef))
          //   .subscribe(() => {
          //     this.loadWorkflowApprovals();
          //   });
        }
      });
  }

  filterInstanceByDataZone(dataZones: DataZone[]): (instance: any) => boolean {
    return (instance): boolean => dataZones.includes(instance.dataZone);
  }

  onChangeTaskChange(changeTask: ChangeTask): void {
    if (changeTask) {
      this.changeTaskApplying = ChangeState.APPLYING === changeTask.changeState;
    }
  }

  deleteServiceDefinition(selectedBlueprintVersion): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('BLUEPRINT_SUMMARY.CONFIRM_DELETE_BLUEPRINT'),
        message: translate('BLUEPRINT_SUMMARY.DELETE_SERVICE_DEFINITION'),
        confirmButtonText: translate('BLUEPRINT_SUMMARY.DELETE')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.isLoading = true;
          this.blueprintsService.deleteBlueprintVersionById(this.blueprint.id, selectedBlueprintVersion)
            .pipe(
              takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
              this.loadBlueprint();
              this.isLoading = false;
              this.loadBlueprintVersion(this.blueprint.id);
            });
        }
      });
  }

  deleteBlueprint(): void {
    if (this.allInstances?.length > 0 || !this.updatedPermissionsMap[PermissionKeys.BLUEPRINT_DELETE]) {
      this.matDialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    } else {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          message: translate('BLUEPRINT_SUMMARY.CONFIRM_DELETE_BLUEPRINT')
        }
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm && this.allInstances?.length === 0) {
          this.isLoading = true;
          this.blueprintsService.deleteBlueprint(this.blueprint.id)
          .pipe(
            finalize(() => this.isLoading = false),
            takeUntilDestroyed(this.destroyRef))
          .subscribe(() => {
            this.router.navigate(['/', this.tenant, RouterSegments.SERVICES, this.service.id]);
          },
          (error) => {
            this.matDialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '566px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('NOTIFICATIONS.DELETE_SERVICE_DEFINITION_FAILED'),
                description: error,
              }
            });
          });
        }
      });
    }
  }

  goToExtendSandbox(): void {
    this.router.navigate([this.tenant, RouterSegments.SERVICES, this.service.id, translate('BLUEPRINT_SUMMARY.EXTEND.EXTEND'),
        this.blueprint.id],
      { state: { installDoc: this.blueprint.installationDocument } });
  }

  viewUpdateResults(instance: Instance): void {
    const data = {
      title: translate('CONFIGURATIONS.STATE.VIEW_RESULTS'),
      subtitle: instance.environment,
      configurationStates: instance.configurationStates,
      configurations: this.configurations,
      viewAllResults: true,
      blueprintId: this.blueprint.id
    };

    this.sidenavService.openInRightSidenav(ViewUpdateResultsComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  retryUpdate(event: any): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      autoFocus: false,
      width: '566px',
      data: {
        title: translate(`BLUEPRINT_SUMMARY.CONFIRM_RETRY.TITLE`),
        message: translate(`BLUEPRINT_SUMMARY.CONFIRM_RETRY.MESSAGE`),
        confirmButtonText: translate('BUTTONS.RETRY')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.applyConfiguration(event.configurationId, event.instanceId, event.configurations);
        }
      });
  }

  gotoSection(section: string): void {
    this.isLoading = false;
    switch (section) {
      case this.blueprintType.INSTANCES:
        this.isInstanceSection = true;
        this.isServiceDefinitionSection = false;
        break;
      case this.blueprintType.SERVICE_DEFINITION:
        this.isInstanceSection = false;
        this.isServiceDefinitionSection = true;
        break;
      default:
        break;
    }
  }

  goBack(): void {
    if (window.history.length > 4) {
      window.history.go(-1);
    }
    else {
      this.router.navigate(['/' + this.tenant]);
    }
  }
  openContactForm(): void {
    window.open('https://itsm-servicedesk.temenos.com/', '_blank');
  }

  isBlueprintsVersionlAvaliable(blueprintVersionList, versionId): any {
    let filterData = [];
    if (versionId && !this.blueprintsVersionList?.error && Array.isArray(blueprintVersionList)) {
      filterData = blueprintVersionList?.filter(item => item.id === versionId);
      this.getVersion = filterData;
    }
    return filterData;
  }

  serviceVersionStatus(versionId): any {
    if (this.allInstances) {
      for (const data of this.allInstances) {
        if(versionId === data.blueprintVersionId) {
          return true;
        }
      }
    }
  }

  getCapabilitiesGroup(blueprintsVersionList: any): any {
    for (const version of blueprintsVersionList) {
      version.capabilitiesGroups = this.frameCapabilities(version.capabilities);
    }
  }

  frameCapabilities(selectedCapabilities: Capability[]): any {
    if (selectedCapabilities?.length > 0) {
      const capabilitiesByType = selectedCapabilities
        .reduce((acc, capability) => {
          if (capability.required !== CapabilityType.OPTIONAL) {
            capability.selected = true;
          }

          let capabilitiesArr = acc[capability.required];
          if (capabilitiesArr == null) {
            capabilitiesArr = [];
            acc[capability.required] = capabilitiesArr;
          }
          capabilitiesArr.push(capability);
          return acc;
        }, {});
      return this.capabilitiesMapping(capabilitiesByType);
    }
  }

  extendedService(capabilities?: Capability): void {
    if (!capabilities) {
      return;
    } else {
      const filteredInstances = this.allInstances.filter(item => this.INSTANCE_FILTERED_STATES.includes(item.status));
      const instanceSolutionVersion = (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.A)) ? (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.A).solutionVersionId)
      : (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.B)) ? (filteredInstances.filter(i => i.deploymentClass === DeploymentClass.B)[filteredInstances.filter(i => i.deploymentClass === DeploymentClass.B).length -1].solutionVersionId)
      : (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.C)) ? (filteredInstances.filter(i => i.deploymentClass === DeploymentClass.C)[filteredInstances.filter(i => i.deploymentClass === DeploymentClass.C).length -1].solutionVersionId)
      : (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.D)) ? (filteredInstances.filter(i => i.deploymentClass === DeploymentClass.D)[filteredInstances.filter(i => i.deploymentClass === DeploymentClass.D).length -1].solutionVersionId)  : this.sortedSolutionVersionId[0].id;
      localStorage.setItem('instanceSolutionVersion', instanceSolutionVersion);
      this.router.navigate(['/', this.tenant, RouterSegments.SERVICES, this.service.id, RouterSegments.EXTEND,
        this.activatedRoute.snapshot.params.blueprintId]);
    }
  }

  gotoWorkBenchURL(instance): void {
    if (this.allInstances.find(instances => instances.id === instance.id)) {
      return instance?.endpoints?.find(endpoint => endpoint.useType === EndpointType.CONFIGURATION);
    }
  }

  onCopyId(data): void {
    this.copy = true;
    this.clipboardApi.copyFromContent(data);
    setTimeout(() => {
      this.copy = false;
    }, 500);
  }

  openUrl(data): void {
    const url = data;
    window.open(url, '_blank');
  }

  public instanceClick(instance): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.service.id,
      RouterSegments.BLUEPRINTS, this.blueprint.id, 'instance', instance.id]);
  }

  private convertDayAndTimeToUTC(dayOfTheWeek, startingHour, endingHour): string {
    const weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    const start = moment(startingHour, 'hh:mm a').day(dayOfTheWeek);
    const end = moment(endingHour, 'hh:mm a').day(dayOfTheWeek);
    if (start.isAfter(end)) {
      end.add(1, 'days');
    }
    const startUTC = start.utc();
    const endUTC = end.utc();
    return weekdays[startUTC.day()] + ':' + startUTC.format('HH:mm') + '-' +
      weekdays[endUTC.day()] + ':' + endUTC.format('HH:mm');
  }

  /**
   * If the conditions are met, we open the table of applied configurations in the right sidenav and get
   * the configuration object ready to be posted
   *
   * @param instance - the row data as instance object
   * @param availableConfigurations - the configurations to be displayed
   */
  private openUpdateConfiguration(instance, availableConfigurations: Configuration[]): void {
    const data = {
      title: translate('INSTANCE_SUMMARY.UPDATE_CONFIGURATION.TITLE'),
      subtitle: instance.name,
      environment: instance.environment,
      availableConfigurations
    };
    this.sidenavService.openInRightSidenav(UpdateConfigurationComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(newConfiguration => {
        if (newConfiguration) {
          this.configStateVerify = false;
          this.applyConfiguration(newConfiguration.id, instance.id, newConfiguration);
        }
      });
  }

  private openUpdateSuccessConfiguration(instance, availableConfigurations: Configuration[]): void {
    const data = {
      title: translate('INSTANCE_SUMMARY.TABLE.UPDATE'),
      subtitle: instance.name,
      instance,
      availableConfigurations
    };
    this.sidenavService.openInRightSidenav(RequestUpdateConfigurationComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(newConfiguration => {
        if (newConfiguration) {
          this.configStateVerify = false;
          this.applyConfiguration(
            newConfiguration.configurationStates[0].configurationId, newConfiguration.configurationStates[0].instanceId);
        }
      });
  }

  private openRequestUpdateConfiguration(instance, availableConfigurations: Configuration[]): void {
    const data = {
      title: translate('INSTANCE_SUMMARY.REQUEST_UPDATE_CONFIGURATION.TITLE'),
      subtitle: instance.name,
      availableConfigurations
    };
    this.sidenavService.openInRightSidenav(RequestUpdateConfigurationComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(newConfiguration => {
        if (newConfiguration) {
          this.configStateVerify = true;
          this.liveInstanceId = instance.id;
          this.verifyConfiguration(newConfiguration.id, instance.id);
        }
      });
  }

  /**
   * Makes a call to post a new configuration. When we get a successful
   * response, we are directed then to the workbench
   *
   * @param configurationId the id of the configuration to be applied
   * @param instanceId - the id of the target instance
   */
  private applyConfiguration(configurationId: string, instanceId: string, config?): void {
    if (this.allInstances.find(instance => instance.id === instanceId).deploymentClass !== DeploymentClass.A) {
      this.matDialog.open(SkiptestPopupComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog',
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          data.skipTest = !data.skipTest;
          this.skipTest = data.skipTest;
          this.applyConfigurationBasedOnInstance(configurationId, instanceId, this.skipTest);
        }
      });
    } else {
      this.skipTest = this.allInstances.find(instance => instance.id === instanceId).deploymentClass === DeploymentClass.A? true : false;
      this.applyConfigurationBasedOnInstance(configurationId, instanceId, this.skipTest);
    }
  }

  private applyConfigurationBasedOnInstance(configurationId, instanceId, skipTest): void {
    this.configurationsService.applyConfiguration(configurationId, instanceId, skipTest)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        // TODO: update only given instance's configurationId and its configuration states
        this.loadData();
      },
      (error) => {
        this.matDialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('NOTIFICATIONS.APPLY_CONFIGURATION_FAILED'),
            description: error,
          }
        });
      });
  }

  private verifyConfiguration(configurationId: string, instanceId: string): void {
    this.configurationsService.verifyConfiguration(configurationId, instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        // TODO: update only given instance's configurationId and its configuration states
        this.loadData();
      },
      (error) => {
        this.matDialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('NOTIFICATIONS.APPLY_CONFIGURATION_FAILED'),
            description: error,
          }
        });
      });
  }
  /**
   * Prepares the guide for the users
   */
  private triggerGuideIfApplicable(): void {
    const tourEnabled = this.tourService.isEnabled();
    const notDemoBlueprint = !this.blueprint.demo;
    const deployedDevInstance = this.devInstance?.status === DeployStatus.DEPLOYED;

    if (tourEnabled && notDemoBlueprint) {
      if (!this.serviceVersionsInfo.currentVersion?.applyConfigurationInstructionId) {
        if (!this.blueprint.pathToLiveConfiguration?.length) {
          this.tourService.start(EnterpriseStepsConfig.DEFINE_WORKFLOW);
        }
      } else if (!this.devInstance) {
        this.tourService.start(EnterpriseStepsConfig.CREATE_DEVELOPMENT_INSTANCE);
      } else if (deployedDevInstance) {
        this.tourService.start(EnterpriseStepsConfig.DEFINE_WORKFLOW);
      }
    }
  }

  private loadWorkflowApprovals(): void {
    this.groupedWorkflowApprovals.clear();
    const eligibleForWorkflowApproval = this.pathToLiveInstances.filter(
      instance => instance.environment === PathToLiveEnvironment.LIVE);
    const entityIds = [];

    if (!eligibleForWorkflowApproval[0]?.id) {
      entityIds.push(this.blueprint.id);
    } else {
      entityIds.push(eligibleForWorkflowApproval[0].id || this.blueprint.id);
    }

    // this.workflowService.search({ entityIds })
    //   .pipe(takeUntilDestroyed(this.destroyRef))
    //   .subscribe(result => {
    //     const workflowApprovals = result.workflowApprovals;
    //     Object.keys(result.workflowApprovals)
    //       .forEach(instanceId => {
    //         workflowApprovals[instanceId].forEach(workflowEntry => this.updateWorkflowEntry(workflowEntry));
    //       });
    //   });
  }

  private updateWorkflowEntry(workflowEntry): void {
    let key = workflowEntry.entity.entityId + workflowEntry.operationType;
    if (workflowEntry?.data.targetEnvironment) {
      key += workflowEntry.data.targetEnvironment;
    }
    this.groupedWorkflowApprovals.set(key, workflowEntry);
  }

  /**
   * Calls urlService method to open the workbench URL in a new tab
   */
  private navigateToWorkbench(event): void {
    event.stopPropagation();
    this.urlService.openUrlInNewTab(this.workbenchUrl);
  }

  /**
   * Returns the dev instance after finding it in the list of instances
   */
  private getDevInstance(allInstances: any): Instance {
    return allInstances.filter(i => i.deploymentClass === DeploymentClass.D);
  }

  /**
   * Sets the dev instance
   */

  private getEndpointTypes(instance: Instance): void {
    const instanceEndpoints: any = instance;
    if(this.isSandbox && instanceEndpoints?.length) {
      instanceEndpoints?.forEach(data => {
        if (data?.endpoints) {
          this.configTypeEndpoints = data.endpoints.filter(endpoint => endpoint.useType === EndpointType.CONFIGURATION);
          this.accessTypeEndpoints = data.endpoints.filter(endpoint => endpoint.useType === EndpointType.UI);
          this.exploreTypeEndpoints = data.endpoints.filter(endpoint => endpoint.useType === EndpointType.API);
          this.otherTypeEndpoints = data.endpoints.filter(endpoint => endpoint.useType === EndpointType.OTHER);
          if (this.configTypeEndpoints.length > 0
            || this.accessTypeEndpoints.length > 0
            || this.exploreTypeEndpoints.length > 0
            || this.otherTypeEndpoints.length > 0) {
            this.isEndpointAvailable = true;
          }

          if (this.configTypeEndpoints.length > 0) {
            this.availableEndpoints = this.availableEndpoints + 1;
          }
          if (this.accessTypeEndpoints.length > 0) {
            this.availableEndpoints = this.availableEndpoints + 1;
          }
          if (this.exploreTypeEndpoints.length > 0) {
            this.availableEndpoints = this.availableEndpoints + 1;
          }
        } else {
          this.isEndpointAvailable = false;
        }
      });
    }
  }

  private setDevInstance(allInstances: Instance[]): void {
    const devInstanceExpanded = this.devInstance?.expanded;
    this.sandboxCreationStatus = allInstances.find(i => i.dataZone === DataZone.DEVELOPMENT)?.status;
    this.devInstance = this.getDevInstance(allInstances);
    this.isDevInstanceDeployed = this.devInstance.find((item)=> this.INSTANCE_DEPLOYED_STATES.includes(item.status));

    if (this.devInstance) {
      this.devInstance.expanded = devInstanceExpanded;
      this.getEndpointTypes(this.devInstance);
    }
  }

  /**
   * Sets the workbench url if present
   */
  private setWorkbenchUrl(): void {
    if (this.devInstance?.length > 0) {
      this.workbenchUrl = this.devInstance[0]?.endpoints?.find(endpoint => endpoint.useType === EndpointType.CONFIGURATION)?.url;
    }
  }

  private setPTLInstances(allInstances: Instance[]): void {
    if (this.blueprint.pathToLiveConfiguration) {
      const instancesMap = allInstances
        .reduce((acc, instance) => {
          acc[instance.id] = instance;
          return acc;
        }, {});

      const expandedMap = {};
      if (this.pathToLiveInstances) {
        this.pathToLiveInstances.reduce((acc, instance) => {
          expandedMap[instance.environment] = instance.expanded;
          return expandedMap;
        }, expandedMap);
      }

      this.pathToLiveInstances = this.blueprint.pathToLiveConfiguration.map((pathToLiveConfiguration, index, pathToLiveArray) => {
        let instance;
        if (pathToLiveConfiguration.instanceId && instancesMap[pathToLiveConfiguration.instanceId]) {
          instance = instancesMap[pathToLiveConfiguration.instanceId];
          instance.environment = pathToLiveConfiguration.environment;
        } else {
          instance = this.buildInstancePlaceholder(pathToLiveConfiguration);
        }

        const previousEnvironment = pathToLiveArray[index - 1];
        if (previousEnvironment) {
          instance.previousInstance = instancesMap[previousEnvironment.instanceId];
        } else if (!this.serviceVersionsInfo.currentVersion?.applyConfigurationInstructionId) {
          // Fake instance to allow deployment of first environment in PTL for non configurable services
          instance.previousInstance = {
            status: DeployStatus.DEPLOYED
          };
        } else {
          instance.previousInstance = this.devInstance[0];
        }

        instance.expanded = expandedMap[instance.environment];
        return instance;
      });
      this.filterPathToLiveInstances();
      this.loadWorkflowApprovals();
    } else {
      // Remove PTL instances if it is a demo blueprint or blueprint without PTL configuration
      delete this.pathToLiveInstances;
      delete this.testDataZoneInstances;
      delete this.piiDataZoneInstances;
    }
  }

  private buildInstancePlaceholder(pathToLiveConfiguration: PathToLiveConfiguration): any {
    return {
      name: `${pathToLiveConfiguration.environment}_${translate('BLUEPRINT_SUMMARY.NA')}`,
      environment: pathToLiveConfiguration.environment,
      deploymentClass: pathToLiveConfiguration.deploymentClass,
      dataZone: pathToLiveConfiguration.dataZone,
      status: DeployStatus.NOT_DEPLOYED
    };
  }

  /**
   * Filters test and PII data zone instances
   */
  private filterPathToLiveInstances(): void {
    if (this.pathToLiveInstances?.length > 0) {
      this.testDataZoneInstances = this.pathToLiveInstances.filter(this.filterInstanceByDataZone([DataZone.DEVELOPMENT]));
      this.piiDataZoneInstances = this.pathToLiveInstances.filter(this.filterInstanceByDataZone([DataZone.SECURE, DataZone.LIVE]));
      this.liveDataZone = this.pathToLiveInstances.filter(this.filterInstanceByDataZone([DataZone.LIVE]));
      this.preProdInstances = this.pathToLiveInstances.filter(this.filterInstanceByDataZone([DataZone.SECURE]));
    } else {
      const instanceData = this.instanceBlueprint.filter((item: any) => item.type !=='other' && item.type !== 'eaas');
      this.devInstances = instanceData?.filter(i => i.deploymentClass === DeploymentClass.D);
      this.testDataZoneInstances = instanceData?.filter(i => i.dataZone !== DataZone.SECURE && i.deploymentClass === DeploymentClass.C || i.deploymentClass === DeploymentClass.B);
      this.piiDataZoneInstances = instanceData?.filter(i => (i.dataZone === DataZone.SECURE && i.deploymentClass === DeploymentClass.C || i.deploymentClass === DeploymentClass.B) || i.deploymentClass === DeploymentClass.A);
      this.liveDataZone = instanceData?.filter(i => i.deploymentClass === DeploymentClass.A);
      this.preProdInstances = instanceData?.filter(i => (i.dataZone === DataZone.SECURE));
    }
  }

  private configureBreadcrumb(blueprint: Blueprint, service: Solution): void {
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({ label: 'Home', url: [] });
    // this.breadcrumbItems.push({ label: translate('CATALOGUE.CATALOGUE'), url: ['catalogue'] });
    // this.breadcrumbItems.push({ label: service.name, url: ['services', service.id] });
    this.breadcrumbItems.push({ label: this.isSandbox ? translate('BLUEPRINT_SUMMARY.EXPLORE_SANDBOX') : blueprint.name });
  }

  /**
   * After the list of configurations is fetched, the active applied configurations are marked
   *
   * @param instances - the instances array
   */
  private prepareActiveConfigurations(instances: any[]): void {
    instances.forEach((instance: any) => {
      if(instance.dataZone === DataZone.LIVE &&instance.latestConfigurationState?.status !== ConfigurationApplicationStatus.VERIFIED) {
        if(instance.latestConfigurationState?.status === ConfigurationApplicationStatus.SUCCESS) {
          instance.activeConfiguration = this.configurations.find(config => config.id === instance.configurationId);
          if(instance.activeConfiguration) {
            this.liveReleaseData = instance.activeConfiguration.manifest.version;
          }
        }
      } else if(instance.dataZone !== DataZone.LIVE) {
        instance.activeConfiguration = this.configurations.find(config => config.id === instance.configurationId);
      }
    });
  }

  private resolveLiveStatus(instances: Instance[]): boolean {
    if (this.isSandbox) {
      return instances[0].status === DeployStatus.DEPLOYED;
    }
    const live = instances.find(instance => instance.deploymentClass === DeploymentClass.A);
    return this.INSTANCE_DEPLOYED_STATES.includes(live?.status);
  }

  private resolveShowCharts(instances: Instance[]): boolean {
    return instances.some(instance => instance.deploymentClass !== DeploymentClass.D
      && this.INSTANCE_DEPLOYED_STATES.includes(instance.status));
  }

  private resolveTrialLabel(): string {

    // const dateCreated = !demoInstance.dateCreated ? this.getExpirationDate(demoInstance.dateCreated) : demoInstance.dateCreated;
    // const label = translate('MY_SERVICES.DEPLOYED') + ' ' + moment(dateCreated).utc().format('DD MMM yyyy hh:mm')+ ' UTC';
    if (!this.isSandbox) {
      return;
    }
    const expirationDate = this.devInstance[0]?.expirationDate;
    const label = translate('BLUEPRINT_SUMMARY.TRIAL_EXPIRES_ON') + ' ' + moment(expirationDate).utc().format('DD MMM yyyy hh:mm')+ ' UTC';

    const lastDate = expirationDate;
    const remainingDays = getDiffDays(new Date(), lastDate);
    if (remainingDays <= 0) {
      return translate('BLUEPRINT_SUMMARY.TRIAL_EXPIRED') + ' ' + moment(expirationDate).utc().format('Do MMM yyyy');
    }

    return label;
  }

  private loadService(): void {
    const serviceId = this.activatedRoute.snapshot.params.serviceId;
    combineLatest([this.solutionsService.getSolutionDetailsById(serviceId), this.solutionsService.getSolutionVersions(serviceId)])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([service, serviceVersions]) => {
        this.service = service;
        this.serviceVersions = serviceVersions;
        this.sortedSolutionVersionId =
          (serviceVersions.sort((a,b) => a?.version && b?.version ? b?.version?.localeCompare(a?.version) : !b?.version ? -1 : 1));
        if(this.serviceVersions[0]?.sandboxType === 'enterprise') {
          this.enterPriseSandbox = true;
        }
        this.publishedServiceVersions = serviceVersions.filter(serviceVersion => serviceVersion.status === translate('VERSIONS.PUBLISHED'));
        // this.includedCapabilities = this.serviceVersions[0].capabilities?.filter(item => item.required === CapabilityType.MANDATORY);
        this.capabilitiesGroups = this.frameCapabilities(this.selectedCapabilities);
        for (const serviceVersionsNotes of this.serviceVersions) {
          this.viewReleaseNotes = serviceVersionsNotes.releaseNotes;
        }
        this.loadBlueprint();
        this.loadInstances();
      }, (err) => this.errorPageService.show404Page());
  }

  private capabilitiesMapping(capabilitiesByType?: any): any {
    return Object.keys(capabilitiesByType)
      .map(capabilityType => ({name: capabilityType, capabilities: capabilitiesByType[capabilityType]}));
  }


  private loadBlueprint(): void {
    this.blueprintsService.getBlueprint(this.blueprintId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(blueprint => {
        this.loader = false;
        if (this.permissionsMap[Permission.NO_SERVICES] && !blueprint.demo) {
          this.errorPageService.show404Page();
        }
        this.extendSandbox = !!(blueprint.capabilities && this.serviceVersions[0].capabilities);
        this.bluerprintById = blueprint;
        // this.selectedCapabilities = blueprint.capabilities?.filter(item => item.required === CapabilityType.OPTIONAL);
        if (!blueprint.demo) {
          this.loadBlueprintVersion(blueprint.id);
        }
        this.onLoadBlueprintSubscription(blueprint);
      }, (err) => this.errorPageService.show404Page());
    if (this.blueprintId) {
      this.blueprintsService.getBlueprintsIdLatestVersion(this.blueprintId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(blueprintLatestVersion => {
          this.blueprintLatestVersion = blueprintLatestVersion;
          this.loadBlueprintVersionById(this.blueprintId, blueprintLatestVersion.id);
        },  (error) => {
          this.toastrService.clear();
            setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });
    }
  }

  private onLoadBlueprintSubscription(blueprint: Blueprint): void {
    this.blueprint = blueprint;
    this.isSandbox = blueprint.demo;
    this.configureBreadcrumb(this.blueprint, this.service);
    this.loadData();
  }

  private loadBlueprintVersion(id: string): void {
    this.blueprintsService.getBlueprintVersion(id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      blueprintVersion => {
        if (blueprintVersion) {
          this.blueprintsVersionList = blueprintVersion;
      }
      this.isInstance = blueprintVersion.length > 1;
      this.blueprintVersion = blueprintVersion[0];
      this.blueprintSingleVersion = blueprintVersion[0];
      this.getCapabilitiesGroup(this.blueprintsVersionList);
    },
    (error) => {
      this.blueprintsVersionList = error;
      }
    );
  }

  private loadBlueprintVersionById(blueprintId: string, id: string): void {
    this.blueprintsService.getBlueprintVersionById(blueprintId, id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      blueprintVersion => {
        this.extendSandbox = !!(blueprintVersion.capabilities && this.serviceVersions[0].capabilities);
        this.selectedCapabilities = blueprintVersion.capabilities;
        this.capabilitiesGroups = this.frameCapabilities(this.selectedCapabilities);
        this.blueprintVersion = blueprintVersion;
      }
    );
  }

  private loadInstances(): void {
    // this.instanceService.getInstancesForSolution(this.service.id)
    //   .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
    //   (instances: any) => {
    //     instances.filter((x) => {
    //       if (x.name === translate('BLUEPRINT_SUMMARY.DEMO_INSTANCE_SANDBOX') && x.blueprintId === this.blueprintId) {
    //         if(x.dateCreated !== x.dateUpdated) {
    //           this.extendSandboxMessage = true;
    //         }
    //         this.instanceId = x.id;
    //       }
    //     });
    //     this.instanceUpdatedMessage(instances);
    //   });
  }


  private loadData(): void {
    this.dataLoaded = false;
    this.titleService.setTitle(this.service?.name);
    if (this.loadDataSubscription) {
      this.loadDataSubscription.unsubscribe();
      this.loadDataSubscription = null;
    }

    this.loadDataSubscription = combineLatest([
      this.loadInstancesWithConfigurationState(this.blueprint.id),
      this.configurationsService.getConfigurations(this.blueprint.id)
    ])
      .pipe(
        finalize(() => this.dataLoaded = true),
        takeUntilDestroyed(this.destroyRef))
      .subscribe(([instances, configurations]) => {
        this.allInstances = instances;
        this.buildNumber = [];
        this.serviceVersionsInfo = this.solutionVersionsService.getSolutionVersionsInfo(this.service, this.serviceVersions, instances);
        this.buildNumber.push(this.isSandbox ? this.serviceVersionsInfo?.devVersion?.version
          : this.serviceVersionsInfo?.currentVersion?.version);

        const liveInstance = this.allInstances.find(instance => instance.deploymentClass === DeploymentClass.A);
        if (liveInstance) {
          this.latestReleaseVersion = this.serviceVersions.filter(version =>
            version.id === liveInstance.solutionVersionId)[0]?.releaseVersion;
        } else {
          const instanceLength = this.allInstances.length;
          const latestInstanceSolutionVersion = this.allInstances[instanceLength - 1]?.solutionVersionId;
          this.latestReleaseVersion = this.serviceVersions.filter(version =>
            version.id === latestInstanceSolutionVersion)[0]?.releaseVersion;
        }

        this.createNewBtnEnable = this.serviceVersions[0]?.capabilities?.length > this.blueprintLatestVersion?.capabilities?.length;
        this.isLive = this.resolveLiveStatus(instances);
        this.showCharts = this.resolveShowCharts(instances);
        this.configurations = configurations;
        this.prepareActiveConfigurations(instances);
        this.setDevInstance(instances);
        this.setWorkbenchUrl();
        this.trialStatus = this.resolveTrialLabel();
        if (this.isExternalClient) {
          this.instancesWithoutPTL(instances);
        } else {
          this.setPTLInstances(instances);
        }
        // TODO: Fix problem with scrolling to element
        // this.triggerGuideIfApplicable();
        if (instances[0]) {
          this.demoInstance = instances[0];
          this.checkIfDeployed();
          this.isInit = true;
        }
        let releaseVersionText;
        if (this.latestReleaseVersion) {
          releaseVersionText = this.latestReleaseVersion;
        } else if (this.isSandbox) {
          releaseVersionText = this.serviceVersionsInfo?.devVersion?.releaseVersion;
        } else {
          releaseVersionText = this.serviceVersionsInfo?.currentVersion?.releaseVersion;
        }

        this.isAMR = releaseVersionText && this.solutionVersionsService.releaseVersion(releaseVersionText) ? true : false;
      }, () => this.errorPageService.show404Page());
  }
  /**
   * Loads instances for a 2.0 customer that do not use PTL
   * @param instances - loaded instance for all the deployment classes
   */
  private instancesWithoutPTL(instances) {
    const deploymentRank: Record<DeploymentClass, number> = {
      [DeploymentClass.D]: 0,
      [DeploymentClass.C]: 1,
      [DeploymentClass.B]: 2,
      [DeploymentClass.A]: 3,
    };

    const instanceData = instances.filter(i => i.type !== 'other' && i.type !== 'eaas')
    .sort(
      (a, b) =>
        deploymentRank[a.deploymentClass] - deploymentRank[b.deploymentClass]
    );
    this.devInstances = instanceData?.filter(i => i.deploymentClass === DeploymentClass.D);
    this.testDataZoneInstances = instanceData?.filter(i => i.dataZone !== DataZone.SECURE && (i.deploymentClass === DeploymentClass.C || i.deploymentClass === DeploymentClass.B));
    this.piiDataZoneInstances = instanceData?.filter(i => (i.dataZone === DataZone.SECURE && i.deploymentClass === DeploymentClass.C || i.deploymentClass === DeploymentClass.B) || i.deploymentClass === DeploymentClass.A);
    this.liveDataZone = instanceData?.filter(i => i.deploymentClass === DeploymentClass.A);
  }

  private loadInstancesWithConfigurationState(blueprintId: string): Observable<Instance[]> {
    return this.instanceService.getInstancesForBlueprint(blueprintId)
      .pipe(mergeMap((instances) => {
        this.instanceBlueprint = instances;
        for (const data of instances) {
          if (data?.endpoints && data.endpoints.length !== 0) {
            this.endpointView = true;
            if (data?.endpoints?.find(endpoint => endpoint.useType === EndpointType.CONFIGURATION)) {
              this.gotoWorkBench = true;
            }
          }
        }
        const latestConfigRequests = instances
          .filter(instance => instance.configurationId)
          .map(instance => this.configurationsService.getConfigurationStates(
            instance.id
          ));
        this.deployedDate = instances.length > 0 ? instances[instances.length - 1].dateUpdated : this.currentDate;
        if (latestConfigRequests.length > 0) {
          return combineLatest(latestConfigRequests).pipe(map(configurationStates => {
            if (configurationStates) {
              configurationStates.forEach(configurationStatesForInstance => {
                if (configurationStatesForInstance?.length > 0) {
                  const instance = instances.find(inst => configurationStatesForInstance[0].instanceId === inst.id);
                  this.setInstanceConfigurationStates(instance, configurationStatesForInstance);
                }
              });
            }
            return instances;
          }));
        }
        return of(instances);
      }
      ));
  }

  private loadConfigurationStatesForInstance(instance: Instance): void {
    this.configurationsService.getConfigurationStates(instance.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(configurationStates => this.setInstanceConfigurationStates(instance, configurationStates));
  }

  private setInstanceConfigurationStates(instance: Instance, configurationStates: ConfigurationState[]): void {
    if (!instance || !configurationStates) {
      return;
    }
    configurationStates.sort((state1, state2) => state2.applicationStartTime.getTime() - state1.applicationStartTime.getTime());
    instance.configurationStates = configurationStates;

    this.configurationStateMessageStatus(instance.configurationStates);

    if (instance.configurationStates?.length > 0) {
      instance.latestConfigurationState = instance.configurationStates[0];
    }
  }

  private configurationStateMessageStatus(config): any {
    const lastRecordTime = config[0]?.applicationFinishTime;
    const getRemainingTime = this.dateTimeService.differenceBetweenDates(lastRecordTime, new Date(), Constants.TIME_UNIT_SECOND);
    let verifyStatus = false;
    if(this.configStateVerify && this.liveInstanceId === config[0]?.instanceId) {
      verifyStatus = true;
    }

    this.configLastRecord.push({
      instanceId: config[0]?.instanceId,
      remainingTime: getRemainingTime,
      status: verifyStatus
    });
  }

  private instanceUpdatedMessage(config): any {
    const updated = config.filter((item)=> item.status === DeployStatus.UPDATED);

    const lastRecordTime = updated[0]?.dateUpdated;
    const getRemainingTime = this.dateTimeService.differenceBetweenDates(lastRecordTime, new Date(), Constants.TIME_UNIT_SECOND);
    this.updateMessageRemainingTime = getRemainingTime;
  }

  private buildDeployDialogData(instance: Instance, title: string): any {
    return {
      title,
      subtitle: instance.environment,
      deployment: {
        blueprintId: this.blueprint.id,
        dataZone: instance.dataZone,
        deploymentClass: instance.deploymentClass,
        targetEnvironment: instance.environment,
        region: this.blueprint.region,
        blueprintVersionId: this.blueprintsVersionList[0]?.id
      } as Deployment,
      service: this.service,
      tenantDetails: this.tenantDetails,
      instanceBlueprint: this.instanceBlueprint

    };
  }

  private updateMaintenanceWindow(): void {
    this.blueprintsService.getBlueprint(this.blueprint.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(blueprint => {
        const blueprintToUpdate = blueprint;
        blueprintToUpdate.updateWindowPolicy = this.updateWindowPolicy;
        this.blueprintsService.updateBlueprint(blueprintToUpdate)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((updatedBlueprint) => {
            this.onLoadBlueprintSubscription(updatedBlueprint);
          });
      }, (err) => this.errorPageService.show404Page());
  }

  private getAvailableConfigurations(instance: Instance): Configuration[] {
    const requiredEnvironment = this.blueprint.pathToLiveConfiguration.find(
      ptl => ptl.environment === instance.environment && ptl.instanceId === instance.id)?.requires;
    let availableConfigurations = this.configurations;
    // Only configurations which are created before (or equal) latest successfully applised configuration on previous environment
    const prodInstance = this.allInstances.find(instances => instances.environment === translate('CONFIGURATIONS.STATE.LIVE'));
    if (instance.environment === translate('CONFIGURATIONS.STATE.LIVE') &&
      prodInstance?.configurationStates?.find(config => config.status === ConfigurationApplicationStatus.VERIFIED)) {
      const latestVerifiedInstance = prodInstance.configurationStates
        .find(configurationState => configurationState.status === ConfigurationApplicationStatus.VERIFIED);
      const verifiedInstanceConfig =
        this.getConfigurationById(latestVerifiedInstance.configurationId);
      availableConfigurations = availableConfigurations
        .filter(configuration => configuration.dateCreated === verifiedInstanceConfig.dateCreated);
    } else if((this.releaseManager && (instance.environment === translate('CONFIGURATIONS.STATE.PREPROD')) && requiredEnvironment)) {
      const requiredInstance = this.allInstances.find(ptlInstance => ptlInstance.environment === requiredEnvironment);
      if(instance.environment === translate('CONFIGURATIONS.STATE.PREPROD')) {
        availableConfigurations = [];
        this.configurations.filter((item) => {
          if(instance.activeConfiguration) {
            const instanceValue = parseInt(instance?.activeConfiguration?.manifest?.version.split('.').shift());
            const originalValue = parseInt(item.manifest.version.split('.').shift());
            if(instanceValue === originalValue) {
              const patchValue = parseInt(item.manifest.version.split('.').pop());
              if(patchValue > 0) {
                availableConfigurations.push(item);
              }
            }
          }
        });
      }
      if (requiredInstance?.configurationStates) {
        const latestSuccessfulStateOfRequiredInstance = requiredInstance.configurationStates
          .find(configurationState => configurationState.status === ConfigurationApplicationStatus.SUCCESS);
        if (latestSuccessfulStateOfRequiredInstance) {
          const configAvailable = this.configurations;
          const latestAppliedConfigurationOnRequiredInstance =
            this.getConfigurationById(latestSuccessfulStateOfRequiredInstance.configurationId);
            for(const configStates of requiredInstance.configurationStates) {
              if (configStates.status === ConfigurationApplicationStatus.SUCCESS) {
                for(const availableConfig of configAvailable) {
                  if(availableConfig.id === configStates.configurationId) {
                    availableConfigurations.push(availableConfig);
                  }
                  availableConfigurations = [...new Set(availableConfigurations)];
                }
              }
            }
        }
      }
    } else if (requiredEnvironment) {
      const requiredInstance = this.allInstances?.find(ptlInstance => ptlInstance.environment === requiredEnvironment);
      if (requiredInstance?.configurationStates) {
        const latestSuccessfulStateOfRequiredInstance = requiredInstance.configurationStates
          .find(configurationState => configurationState.status === ConfigurationApplicationStatus.SUCCESS);
        if (latestSuccessfulStateOfRequiredInstance) {
          const configAvailable = availableConfigurations;
          const latestAppliedConfigurationOnRequiredInstance =
            this.getConfigurationById(latestSuccessfulStateOfRequiredInstance.configurationId);
            if (requiredEnvironment === PathToLiveEnvironment.PREPROD) {
              availableConfigurations = latestAppliedConfigurationOnRequiredInstance ? [latestAppliedConfigurationOnRequiredInstance] : [];
            } else {
            availableConfigurations = [];
            for(const configStates of requiredInstance.configurationStates) {
              if (configStates.status === ConfigurationApplicationStatus.SUCCESS) {
                for(const availableConfig of configAvailable) {
                  if(availableConfig.id === configStates.configurationId) {
                    availableConfigurations.push(availableConfig);
                  }
                  availableConfigurations = [...new Set(availableConfigurations)];
                }
              }
            }
          }
          const latestVersion = latestAppliedConfigurationOnRequiredInstance?.manifest?.version;
          if (latestVersion && requiredEnvironment !== 'PREPROD') {
    
            const [latestMajor, latestMinor] = latestVersion.split('.').map(num => parseInt(num, 10));
            
            availableConfigurations = this.configurations.filter(item => {
              const [major, minor, patch] = item.manifest.version.split('.').map(num => parseInt(num, 10));
              // version is less than selected major.minor
              const isLowerVersion = major < latestMajor || (major === latestMajor && minor < latestMinor);
              // version belongs to same major.minor (hotfixes)
              const isHotfix = major === latestMajor && minor === latestMinor;
              return isLowerVersion || isHotfix;
            });
          }
          availableConfigurations.sort((a, b) => {
            const asort = a.manifest.version.split('.').map(num => parseInt(num, 10));
            const bsort = b.manifest.version.split('.').map(num => parseInt(num, 10));

            for (let i = 0; i < 3; i++) {
              if (asort[i] > bsort[i]) return 1;
              if (asort[i] < bsort[i]) return -1;
            }
            return 0;
          });
        } else {
          availableConfigurations = [];
        }
      } else {
        availableConfigurations = [];
      }
    }
    if (instance?.configurationStates) {
      const latestSuccessfulState = instance.configurationStates
        .find(configurationState => configurationState.status === ConfigurationApplicationStatus.SUCCESS);
      if (latestSuccessfulState) {
        const latestAppliedConfiguration = this.getConfigurationById(latestSuccessfulState.configurationId);
        availableConfigurations = availableConfigurations
          .filter(configuration =>
            this.compareVersions(configuration.version, latestAppliedConfiguration.version) > 0 );
      }
    }
    if(availableConfigurations?.length > 0) {
          availableConfigurations.sort((a, b) => {
            const asort = a.manifest.version.split('.').map(num => parseInt(num, 10));
            const bsort = b.manifest.version.split('.').map(num => parseInt(num, 10));

            for (let i = 0; i < 3; i++) {
              if (asort[i] > bsort[i]) return 1;
              if (asort[i] < bsort[i]) return -1;
            }
            return 0;
          });
        }
    return availableConfigurations;
  }

  compareVersions(version: string, latestVersion: string): number {
    const version1 = version.split('.').map(num => parseInt(num, 10));
    const version2 = latestVersion.split('.').map(num => parseInt(num, 10));
    for (let i = 0; i < Math.max(version1.length, version2.length); i++) {
      if (version1[i] > version2[i]) return 1;
      if (version1[i] < version2[i]) return -1;
    }
    return 0;
  }
  private getConfigurationById(configurationId: string): Configuration {
    return this.configurations.find(configuration => configuration.id === configurationId);
  }

  /**
   * Handles the actual creation of an instance by
   * posting the deployment object. On successful response,
   *
   * @param deployment - the deployment object to be posted
   */
  private deployInstance(deploymentData): Observable<any> {
    const result = new Subject();
    if (deploymentData.targetEnvironment) {
      this.devInstanceEnvironment = deploymentData.targetEnvironment + ' ' + translate('NOTIFICATIONS.DEPLOYMENT_FAILED');
    } else {
      this.devInstanceEnvironment = deploymentData.dataZone  + ' ' + translate('NOTIFICATIONS.INSTANCE_FAILED');
    }
    this.updateWindowPolicy = null;
    // if (deploymentData.dataZone === DataZone.LIVE) {
    //   this.updateWindowPolicy = this.convertDayAndTimeToUTC(deploymentData.dayOfTheWeek,
    //     deploymentData.startingHour, deploymentData.endingHour);
    // } else {
    //   this.updateWindowPolicy = null;
    // }
    delete deploymentData.dayOfTheWeek;
    delete deploymentData.startingHour;
    delete deploymentData.endingHour;
    this.deploymentsService.createAndDeploy(deploymentData)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loadBlueprint();
      }, (error) => {
        this.matDialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title: this.devInstanceEnvironment,
            description: error,
          }
        });
      });
    return result;
  }

  private subscribeForNotifications(): void {
    this.notificationsService.onAnyNotification([
      { type: 'com.temenos.engine.instance', data: { status: 'created' } },
      { type: 'com.temenos.engine.instance', data: { status: 'deleted' } },
      { type: 'com.temenos.engine.instance', data: { status: 'updated' } }
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        if (notification.data?.blueprintId === this.blueprint?.id) {
          this.loadBlueprint();
        }
      });

    this.notificationsService.onNotification({ subject: 'Workflow approval' })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        if (notification.data?.blueprintId === this.blueprint?.id) {
          this.loadWorkflowApprovals();
        }
      });

    this.notificationsService.onAnyNotification([
      { type: 'com.temenos.saas.engine.configuration' },
      { subject: 'Change Task', data: { status: 'published' } },
      { subject: 'Change Task', data: { status: 'rejected' } },
      { subject: 'Change Task', data: { status: 'applying' } },
      { subject: 'Change Task', data: { status: 'applied' } }
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        // TODO: Engine should add blueprintId to data! When they add it remove first if condition
        if (notification.data?.instanceId === this.devInstance.id) {
          this.loadData();
        } else if (notification.data?.blueprintId === this.blueprint?.id) {
          this.loadData();

          if (notification.subject === 'Change Task' && notification.data.status === 'applied') {
            this.changeTaskApplying = false;
          }
        }
      });

    this.notificationsService.onAnyNotification([
      { type: 'com.temenos.saas.engine.configuration.apply' },
      { type: 'com.temenos.saas.engine.configuration.verify' }
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        const updatedInsance = this.allInstances?.find(instance => instance.id === notification.data?.instanceId);
        if (updatedInsance) {
          this.loadData();
        }
      });
  }

  private refreshInstanceForm(): void {
    this.isLoading = true;
    this.loadData();
    this.isLoading = false;

    this.count = this.count !== 1 ? 1 : 0;
    this.defaultState = true;
    this.defaultState = false;
  }

  private checkIfDeployed(): void {
    if (this.demoInstance.status === DeployStatus.DEPLOYED) {
      this.showStepsLoadingSection = false;
    }
  }

  private subscribeForNotification(): void {
    this.notificationsService.onNotification(
      { type: 'com.temenos.engine.instance', data: { status: 'created' } }
    )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        if (notification.data?.id === this.demoInstance?.id) {
          this.instanceService.getInstanceById(this.demoInstance.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
            (instance) => {
              this.demoInstance = instance;
              this.getEndpointTypes(this.demoInstance);
              this.checkIfDeployed();
            });
        }
      });
  }

  private isUpdated(capability): boolean {
    if (this.selectedCapabilities) {
      return this.selectedCapabilities.some(e => e.name === capability.name);
    }
  }

  private updateConfiguration(instance, event): void {
    event.stopPropagation();
    this.updateReleasePackage = this.getAvailableConfigurations(instance).length;
  }

  private defaultComparator(config1: Configuration, config2: Configuration): number {
    if (config1?.manifest?.dataGenerated && config2?.manifest?.dataGenerated) {
      return new Date(config2.manifest.dataGenerated).getTime() - new Date(config1.manifest.dataGenerated).getTime();
    }
    return 0;
  }

  onSupportClick(): void { 
    window.open('https://itsm-servicedesk.temenos.com/', '_blank');

  }

  liveInstance(data): void {
    this.matDialog.open(ConfigDialogLiveComponent, {
       minHeight: '272px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title: translate('NOTIFICATIONS.LIVE_CONFIGURATION'),
            description: translate('NOTIFICATIONS.LIVE_CONFIGURATION_MSG'),
          }
      });
  }


}
